module.exports = __webpack_public_path__ + "static/media/resume.ff446c09.pdf";